module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_7016.2201c389.png";